<template>
    <div class="activity-list">
        <div :class="{'activity-item': true, [activity.step]: true}" v-for="activity in dataList" :key="activity.activityid">
            <router-link :to="`/ActivityDetail/${activity.activityid}`" class="activity-pic-wrapper">
                <img :src="activity.coverpicurl" alt="" :class="{'activity-pic': true, 'hide': !activity.coverpicurl}">
            </router-link>
            <div class="activity-item-r">
                <h2 class="title"><router-link :to="`/ActivityDetail/${activity.activityid}`" v-text="activity.title"></router-link></h2>
                <div class="activity-info">
                    <div class="activity-c-time">
                        <span class="time-h">活動日期:</span>
                        <span class="time-v" v-text="activity.starttime + '至' +activity.endtime"></span>
                    </div>
                    <span class="association-name" v-text="activity.associationname"></span>
                </div>
                <p class="content" v-text="activity.introduce"></p>
            </div>
            <div class="btn-status" v-text="activity.statusText"></div>
        </div>
        <split-page v-if="visible" :initData="{pageNo, pageSize, total}" :onPageChanged="onPageChanged"/>
        <loading v-if="loading" />
    </div>
</template>

<script>
    import SplitPage from '../../components/SplitPage.vue'
    import Loading from '../Loading.vue'
    export default {
        components: {
            SplitPage,
            Loading,
        },
        data(){
            return {
                visible: true,
                pageNo: 1,
                pageSize: 20,
                total: 4,
                loading: false,
                dataList: [],
                keyword: '',
            }
        },
        mounted: function(){
            this.keyword = this.$route.query.keyword || ''
            this.onRefresh()
        },
        methods: {
            onPageChanged: function(page){
                this.pageNo = page
                this.onRefresh()
            },
            onRefresh: function(){
                this.loading = true
                this.$store.dispatch('getActivityList', {
                    associationid: 4,
                    keyword: this.keyword.trim() || undefined,
                    pageNo: this.pageNo,
                    pageSize: this.pageSize,
                }).then(rs=>{
                    this.loading = false
                    var list = rs.list || []
                    list.forEach((data)=>{
                        var start = data.starttime && new Date(data.starttime.replace(/-/g, '/')).getTime()
                        var end = data.endtime && new Date(data.endtime.replace(/-/g, '/')).getTime()
                        var now = Date.now()
                        if(now < start) {
                            data.step = 'step0'
                            data.statusText = '未進行'
                        } else if(now > end) {
                            data.step = 'step2'
                            data.statusText = '已結束'
                        } else {
                            data.step = 'step1'
                            data.statusText = '進行中'
                        }
                    })
                    this.dataList = list
                    this.total = rs.total || 0
                    this.visible = this.total > 0                    
                }).catch(error=>{
                    this.loading = false
                    this.$message.warning(error)
                })
            }
        },
        watch: {
            '$props.keyword': function(keyword) {
                if(keyword == null) {
                    return
                }
                this.keyword = keyword || ''
                this.onRefresh()
            },
            '$route.query.keyword': function(keyword) {
                this.keyword = keyword || ''
                this.onRefresh()
            },
        }
    }
</script>

<style scoped>
    .activity-list {
        width: 100%;
        display: flex;
        flex-direction: column;
        position: relative;
        background-color: #fff;
        padding: 12px;
        padding-bottom: 60px;
        border: 1px solid #e8e8e8;
        box-shadow: 1px 1px 1px #e9e7e7;
    }

    .activity-list > .activity-item {
        display: flex;
        flex-direction: row;
        position: relative;
        background-color: #fff;
        margin-bottom: 20px;
        padding: 8px;
        justify-content: flex-start;
        align-items: flex-start;
    }

    .activity-list > .activity-item:last-child {
        margin-bottom: 0px;
    }

    .activity-list > .activity-item.step2 {
        background-color: #F4F4F4;
    }

    .activity-list > .activity-item.step2::after {
        content: '';
        position: absolute;
        left: 18px;
        top: 40px;
        width: 120px;
        height: 100px;
        background-image: url(../../assets/imgs/img_wanjie@2x.png);
        background-size: 100% 100%;
        background-repeat: no-repeat;
    }

    .activity-list > .activity-item > .activity-pic-wrapper {
        width: 140px;
        height: 120px;
        margin-right: 10px;
        margin-top: 20px;
        background-color: #ddd;
    }

    .activity-list > .activity-item > .activity-pic-wrapper > .activity-pic {
        width: 140px;
        height: 120px;
    }
    .activity-list > .activity-item > .activity-pic-wrapper > .activity-pic.hide {
        display: none;
    }

    .activity-list > .activity-item > .activity-item-r {
        display: flex;
        flex-direction: column;
        flex: 1;
    }

    .activity-list > .activity-item .title {
        line-height: 22px;
        font-size: 18px;
        font-weight: bold;
        color: #231F20;
        margin-top: 22px;
    }

    .activity-list > .activity-item.step2 .title {
        color: #636363;
    }

    .activity-list > .activity-item .activity-info {
        display: flex;
        flex-direction: row;
        margin-top: 13px;
        margin-bottom: 20px;
        justify-content: space-between;
    }

    .activity-list > .activity-item .activity-info > .association-name {
        color: #969696;
        font-size: 14px;
        font-weight: 400;
        line-height: 13px;
        flex: 1;
        text-align: right;
        margin-left: 12px;
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 1;
		-webkit-box-orient: vertical;
    }

    .activity-list > .activity-item .activity-info .activity-c-time {
        display: flex;
        flex-direction: row;
    }

    .activity-list > .activity-item .activity-info .activity-c-time > .time-h {
        color: #969696;
        font-size: 14px;
        font-weight: 400;
        line-height: 13px;
    }

    .activity-list > .activity-item .activity-info .activity-c-time >  .time-v {
        color: #969696;
        font-size: 14px;
        font-weight: 400;
        margin-left: 8px;
        line-height: 13px;
    }

    .activity-list > .activity-item .content {
        font-size: 14px;
        font-weight: 400;
        color: #636363;
        line-height: 21px;
        display: inline-block;
        margin-bottom: 12px;
    }

    .activity-list > .activity-item .btn-status {
        position: absolute;
        right: 20px;
        top: 26px;
        width: 66px;
        height: 22px;
        line-height: 22px;
        text-align: center;
        font-weight: bold;
        color: #FF8000;
        background-color: #FFE3D5;
        border-radius: 11px;
        font-size: 14px;
    }

    .activity-list > .activity-item.step0 .btn-status {
        color: #FF8000;
        background-color: #FFE3D5;
    }

    .activity-list > .activity-item.step1 .btn-status {
        color: #36C4D0;
        background-color: #DCF7FB;
    }

    .activity-list > .activity-item.step2 .btn-status {
        color: #231F20;
        background-color: #E8E8E8;
    }
    
    @media only screen and (max-width: 1050px) {
        .activity-list > .activity-item > .activity-pic-wrapper {
            width: 70px;
            height: 60px;
            margin-right: 10px;
            margin-top: 10px;
            background-color: #ddd;
        }

        .activity-list > .activity-item > .activity-pic-wrapper > .activity-pic {
            width: 70px;
            height: 60px;
        }

        .activity-list > .activity-item .content {
            margin-left: -80px;
        }

        .activity-list > .activity-item.step2::after {
            content: '';
            position: absolute;
            left: 12px;
            top: 21px;
            width: 60px;
            height: 50px;
            background-image: url(../../assets/imgs/img_wanjie@2x.png);
            background-size: 100% 100%;
            background-repeat: no-repeat;
        }

        .activity-list > .activity-item .activity-info .activity-c-time {
            display: block;
        }

        .activity-list > .activity-item .title {
            height: unset;
            line-height: 21px;
            margin-top: 8px;
        }

        .activity-list > .activity-item .btn-status {
            left: 8px;
            top: 86px;
        }
    }
</style>
